<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <!-- Top Navigation -->
    <div class="vx-row">

      <!-- CARD 1: PARTNER GAINED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base" v-if="user_info.role == 'SUPERADMIN' || user_info.role == 'DEVELOPER' ">
        <vx-card>
          <div style="display:flex; justify-content:space-between" class="text-primary cursor-pointer testing" @mouseover="setThis(1)" @mouseleave="setThis(0)" >
            <h3><router-link :to="{name:'group-list'}" class="text-inherit underline">Group/组权限</router-link></h3>
            <feather-icon icon="BoxIcon" svgClasses="stroke-current w-8 h-8" class="ml-2 " :class="ishover == 1 ? 'text-primary' : 'text-dark' "/> 
          </div>
        </vx-card>
      </div>

      <!-- CARD 2: USER GAINED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <vx-card>
          <div style="display:flex; justify-content:space-between" class="text-primary cursor-pointer testing" @mouseover="setThis(2)" @mouseleave="setThis(0)">
            <h3><router-link :to="{name:'yonghu-list'}" class="text-inherit underline">User/用户</router-link></h3>
            <feather-icon icon="UsersIcon" svgClasses="stroke-current w-8 h-8" class="ml-2" :class="ishover == 2 ? 'text-primary' : 'text-dark' "/> 
          </div>
        </vx-card>
      </div>

      <!-- CARD 3: CUSTOMER GAINED -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <vx-card>
          <div style="display:flex; justify-content:space-between" class="text-primary cursor-pointer testing" @mouseover="setThis(3)" @mouseleave="setThis(0)">
            <h3><router-link :to="{name:'kehu-list'}" class="text-inherit underline">Customer/顾客</router-link></h3>
            <feather-icon icon="UsersIcon" svgClasses="stroke-current w-8 h-8" class="ml-2" :class="ishover == 3 ? 'text-primary' : 'text-dark' "/> 
          </div>
        </vx-card>
      </div>

      <!-- CARD 4: LOAN ACCOUNT -->
      <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base">
        <vx-card>
          <div style="display:flex; justify-content:space-between" class="text-primary cursor-pointer testing" @mouseover="setThis(4)" @mouseleave="setThis(0)">
            <h3><router-link :to="{name:'daikuan-list'}" class="text-inherit underline">Loan/贷款</router-link></h3>
            <feather-icon icon="BriefcaseIcon" svgClasses="stroke-current w-8 h-8" class="ml-2" :class="ishover == 4 ? 'text-primary' : 'text-dark' "/> 
          </div>
        </vx-card>
      </div>
    </div>

    <!-- Upcoming Loan List -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <vx-card title="Upcoming Loan List"  collapse-action>
          <div class="vx-row">
            <div class="vx-col w-full md:w-1/3 lg:w-1/4">
              <datepicker :inline="true" v-model="selectedDate"></datepicker>
            </div>
            <div class="vx-col w-full md:w-2/3 lg:w-3/4">
              <vx-card :title="tableTitle" refresh-content-action @refresh="refreshData" ref="loanTable">
                <vs-table pagination max-items="10" search :data="todayListFilter">
                  <template slot="thead">
                    <vs-th sort-key="account_no">账号</vs-th>
                    <vs-th sort-key="due_date">期限</vs-th>
                    <vs-th sort-key="installment_amount">数额</vs-th>
                    <vs-th sort-key="paid_date">还账日期</vs-th>
                    <vs-th sort-key="status">状态</vs-th>
                    <vs-th sort-key="updated_at">DATETIME</vs-th>
                    <vs-th>ACTION</vs-th>
                  </template>

                  <template slot-scope="{data}">
                    <vs-tr :class="data[indextr].status == 'PAID' ? 'tr-table-state-success' : 'tr-table-state-warning' " :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                      <vs-td :data="data[indextr].account_no">
                        {{ data[indextr].account_no }}
                      </vs-td>

                      <vs-td :data="data[indextr].due_date">
                        {{ data[indextr].due_date }}
                      </vs-td>

                      <vs-td :data="data[indextr].installment_amount">
                        {{ data[indextr].installment_amount }}
                      </vs-td>

                      <vs-td :data="data[indextr].paid_date">
                        {{ data[indextr].paid_amount ? data[indextr].paid_amount+' / '+data[indextr].paid_date : '-' }}
                      </vs-td>

                      <vs-td :data="data[indextr].status">
                        <vs-chip :color="data[indextr].status == 'PAID' ? 'success' : 'warning' "> {{ data[indextr].status }}</vs-chip>
                       
                      </vs-td>

                      <vs-td :data="data[indextr].updated_at">
                        {{ formatDate(data[indextr].updated_at) }}
                      </vs-td>

                      <vs-td :data="data[indextr].updated_at">
                        <vs-button size="small" color="dark" type="border" icon-pack="feather" icon="icon-edit">View</vs-button>
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
                <template slot="footer" v-if="user_info.role == 'DEVELOPER' ">
                  <vs-divider />
                  <div class="flex justify-between">
                    <div>
                      <h4 style="color: rgb(0, 0, 255);">Without Filter : {{todayList.length}}</h4>
                    </div>
                    <div>
                      <h4>Total : {{todayListFilter.length}}</h4>
                    </div>
                    <div>
                      <h4 style="color: rgb(0, 121, 18);">Completed : <span>{{todayListSuccess.length}}</span></h4>
                    </div>
                    <div>
                      <h4 style="color: rgb(182, 101, 29);">Ongoing : <span>{{todayListFilter.length - todayListSuccess.length}}</span></h4>
                    </div>
                  </div>
                </template>
              </vx-card>
            </div>
          </div>
        </vx-card>
      </div>

    </div>
    
    <div class="vx-row mt-5" v-if="user_info.role == 'DEVELOPER'">
      <!-- <div class="vx-col w-full md:w-1/3 lg:w-1/3 xl:w-1/3">
          <statistics-card-line
            class="md:mb-0 mb-base"
            icon="UserCheckIcon"
            icon-right
            statistic="659.8k"
            statisticTitle="Active Users"
            :chartData="series"
            color="success" />
      </div> -->
      <!-- PRODUCT ORDERS -->
      <div class="vx-col w-full lg:w-1/3 mb-base">
        <vx-card title="Customers Age Group">
          <!-- SLOT = ACTIONS -->
          <!-- <template slot="actions">
              <change-time-duration-dropdown />
          </template> -->

          <div slot="no-body">
              <!-- CHART -->
              <vue-apex-charts type="pie" height="334" class="my-12" :options="customersData.chartOptions" :series="customersData.series" />

              <!-- CHART DATA -->
              <ul class="mb-1" v-if="flag_ready">
                  <li v-for="customerData in customersData.analyticsData" v-if="customersData.analyticsData.length > 0" :key="customerData.customerType" class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0">
                      <span class="flex items-center">
                          <span class="inline-block h-3 w-3 rounded-full mr-2" :class="`bg-${customerData.color}`"></span>
                          <span class="font-semibold">{{ customerData.customerType }}</span>
                      </span>
                      <span>{{ customerData.counts }}</span>
                  </li>
              </ul>
          </div>

        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
// import analyticsData from './ui-elements/card/analyticsData.js'
import ChangeTimeDurationDropdown from '@/components/ChangeTimeDurationDropdown.vue'
// import VxTimeline from '@/components/timeline/VxTimeline'

import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'
import moduleCustomerManagement from '@/store/customer-management/moduleCustomerManagement.js'
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';

export default {

  data () {
    return {
      invalidID: [],
      validID: [],
      lists: [],
      selectedDate: '',
      todayList: [],
      series: [
        {
          name: 'Active Users',
          data: [750, 1000, 900, 1250, 1000, 1200, 1100]
        }
      ],

     
      customersData: {
        chartOptions: {
          labels: ['> 45', '22-44', '< 22','Invalid'],
          dataLabels: {
            enabled: false
          },
          legend: { show: false },
          chart: {
            type: 'pie',
            offsetY: 0,
            dropShadow: {
              enabled: false,
              blur: 5,
              left: 1,
              top: 1,
              opacity: 0.2
            },
            toolbar: {
              show: false
            }
          },
          stroke: {
            width: 5
          },
          colors: ['#7961F9', '#FF9F43', '#EA5455', '#FAF4F0'],
          fill: {
            type: 'gradient',
            gradient: {
              gradientToColors: ['#9c8cfc', '#FFC085', '#f29292','#f25F9F']
            }
          }
        },
        analyticsData: [
          
        ],
        series: [70, 52, 26, 20]
      },
      // checkpointReward: {},
      // subscribersGained: {},
      // ordersRecevied: {},
      // salesBarSession: {},
      // supportTracker: {},
      // productsOrder: {},
      // salesRadar: {},

      // timelineData: [
      //   {
      //     color: 'primary',
      //     icon: 'PlusIcon',
      //     title: 'Client Meeting',
      //     desc: 'Bonbon macaroon jelly beans gummi bears jelly lollipop apple',
      //     time: '25 mins Ago'
      //   },
      //   {
      //     color: 'warning',
      //     icon: 'MailIcon',
      //     title: 'Email Newsletter',
      //     desc: 'Cupcake gummi bears soufflé caramels candy',
      //     time: '15 Days Ago'
      //   },
      //   {
      //     color: 'danger',
      //     icon: 'UsersIcon',
      //     title: 'Plan Webinar',
      //     desc: 'Candy ice cream cake. Halvah gummi bears',
      //     time: '20 days ago'
      //   },
      //   {
      //     color: 'success',
      //     icon: 'LayoutIcon',
      //     title: 'Launch Website',
      //     desc: 'Candy ice cream cake. Halvah gummi bears Cupcake gummi bears soufflé caramels candy.',
      //     time: '25 days ago'
      //   },
      //   {
      //     color: 'primary',
      //     icon: 'TvIcon',
      //     title: 'Marketing',
      //     desc: 'Candy ice cream cake. Halvah gummi bears Cupcake gummi bears.',
      //     time: '28 days ago'
      //   }
      // ],


      // analyticsData,
      // dispatchedOrders: [],

      // subscriberPartner: []
      ishover: 0,
      flag_ready: false,
    }
  },
  components: {
    VueApexCharts,
    StatisticsCardLine,
    ChangeTimeDurationDropdown,
    // VxTimeline
    Datepicker
  },
  computed: {
    customers () {
      return this.$store.state.customerManagement.customers
    },
    permissions () {
      if(this.$store.state.AppActiveUser && this.$store.state.AppActiveUser.permissions){
        return this.$store.state.AppActiveUser.permissions;
      }
      else{
        return []
      }
    },
    user_info(){
      let data = JSON.parse(sessionStorage.getItem('userInfo'));
      return data
    },
    tableTitle(){
      return moment(this.selectedDate).format('YYYY-MM-DD')+" 的贷款 (Total "+this.todayListFilter.length+" lists)"
    },
    todayListFilter(){
      return this.todayList.filter(function(item){
        return item.status !== 'VOID'
      })
    },
    todayListSuccess(){
      return this.todayList.filter(function(item){
        return item.status == 'PAID'
      })
    }
  },
  methods: {
    goto(target){

    },
    checkAge(data){
      var current_year = moment().year()
      var current_year_lasttwo = parseInt(current_year.toString().substring(2))
      let first_two = parseInt(data.substring(0,2))
      let complete_year = ''
      if(first_two > current_year_lasttwo){
        complete_year=1900+first_two
      }
      else{
        complete_year=2000+first_two
      }
      return current_year - complete_year
    },
    calculateCustomerAgeRange(){
      let self = this
      console.log('this customer',this.customers)
      this.customers.forEach(function(item){
        if(item.idno.length > 10){
          self.validID.push(item)
        }
        else{
          self.invalidID.push(item)
        }
      })

      if(this.validID.length > 0){
        let above45 = 0, between2244 = 0, lessthan22 = 0
        this.validID.forEach(function(item){
          let age = self.checkAge(item.idno)
          if(age >= 45){
            above45++
          }
          else if(age >= 22 && age < 45){
            between2244++
          }
          else{
            lessthan22++
          }
        })
        this.customersData.analyticsData = [
          {
            'color':"primary",
            'counts':above45,
            'customerType':"> 45"

          },
          {
            'customerType': '22-44',
            'counts': between2244,
            'color': 'warning'
          },
          {
            'customerType': '< 22',
            'counts': lessthan22,
            'color': 'danger'
          },
          {
            'customerType': 'Invalid',
            'counts': self.invalidID.length,
            'color': 'danger'
          }
        ]
        this.flag_ready = true
      }
      
    },
    setThis(target){
      this.ishover = target
    },
    refreshData(cardName){
      let self = this
      console.log('refresh datatable')
      const baseURI = 'installment_terms/list'
      let formData = new FormData();
      formData.append('start_date', moment(this.selectedDate).format('YYYY-MM-DD'));
      formData.append('end_date', moment(this.selectedDate).format('YYYY-MM-DD'));
      this.$http.post(baseURI,formData)
      .then((result) => {
        if(result.data.status == 'success'){
          // console.log('preload load',result.data)
          this.todayList = result.data.data
          if(!cardName) return
          else cardName.removeRefreshAnimation(1000)
        }
      })
    },
  },
  beforeCreate () {
    // console.log('hi ther',sessionStorage.getItem('accessToken'),this.$store.state.isLogged)
    if (this.$store.state.isLogged) {
      this.$router.push({ name: 'login' })
    }
  },
  created () {
    this.selectedDate = new Date()
    if (!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
    if (!moduleCustomerManagement.isRegistered) {
      this.$store.registerModule('customerManagement', moduleCustomerManagement)
      moduleCustomerManagement.isRegistered = true
    }

    if( this.permissions.includes('*') || this.permissions.includes('012')){
      this.$store.dispatch('userManagement/fetchUsers').then((data) => {
        console.log('preload user')
      }).catch(err => { 
        if(err.logout){
          this.$vs.notify({
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            title: err.msg
          })
          sessionStorage.removeItem('accessToken')
          sessionStorage.removeItem('user')
          sessionStorage.removeItem('loan_info')
          this.$router.push('/pages/login').catch(() => {})
        }
        console.error(err,'userManagement/fetchUsers') 
      })
    }
    if( this.permissions.includes('*') || this.permissions.includes('022')){
      let formData = new FormData()
      formData.append('val', '' )
      formData.append('status', 'ACTIVE,INACTIVE' )
      let obj = {
        form_data:formData
      }
      this.$store.dispatch('customerManagement/fetchCustomers', obj).then((data) => {
        console.log('preload customer')
        this.calculateCustomerAgeRange()
      })
    }
    if( this.permissions.includes('*') || this.permissions.includes('032')){
      // const baseURI = 'loans/list'
      // let formData = new FormData();
      // formData.append('status', 'ACTIVE,COMPLETE');
      // this.$http.post(baseURI,formData)
      // .then((result) => {
      //   if(result.data.status == 'success'){
      //     console.log('preload load')
      //     // console.log(result.data.data)
      //     this.lists = result.data.data
      //   }
      // })
      this.$store.dispatch('userManagement/fetchLoans').then((data) => {
        console.log('preload loan list')
      }).catch(err => { 
        if(err.logout){
          this.$vs.notify({
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger',
            title: err.msg
          })
          sessionStorage.removeItem('accessToken')
          sessionStorage.removeItem('user')
          sessionStorage.removeItem('loan_info')
          this.$router.push('/pages/login').catch(() => {})
        }
        console.error(err,'userManagement/fetchLoans') 
      })
    }
  },
  watch: {
    selectedDate(val){
      if(val){
        this.refreshData()
      }
    },
  },
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .tr-table-state-success{
    color: rgba(var(--vs-success),1);
    box-shadow: 0 0 1px 0 rgba(var(--vs-success),1)!important;
    background: rgba(var(--vs-success),.1)!important;
  }
  .tr-table-state-warning{
    background: rgba(var(--vs-warning),.1)!important;
    color: rgba(var(--vs-warning),1);
    box-shadow: 0 0 1px 0 rgba(var(--vs-warning),1)!important;
  }
  .vdp-datepicker__calendar{
    width: 100%;
  }


  .vx-card__body{
    padding: 1rem;

    .testing{
      align-items: center;
      &:hover{
          
        h3{
          color:blue;
        }

      }
    }

    h3{
      font-size:1.2rem;
    }
  }
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
